/* eslint-disable react-refresh/only-export-components -- co-exports hooks/helpers alongside a component by design */
import { createContext, useContext, useState } from 'react'

const SEASONS = ['2026', '2027'] as const
export type Season = typeof SEASONS[number]

// Temporary lock: pin the whole app to 2027 until historical (2026) data is ready
// to expose (Kamari 2026-09-23). Set to null to restore the switcher — the season
// plumbing stays intact underneath. `locked` drives the read-only switcher UI.
const SEASON_LOCK: Season | null = '2027'

const SeasonContext = createContext<{
  season: Season
  setSeason: (s: Season) => void
  locked: boolean
}>({ season: '2027', setSeason: () => {}, locked: SEASON_LOCK !== null })

export function SeasonProvider({ children }: { children: React.ReactNode }) {
  const [season, setSeasonState] = useState<Season>(() => {
    if (SEASON_LOCK) return SEASON_LOCK
    const stored = localStorage.getItem('active-season')
    return (SEASONS as readonly string[]).includes(stored ?? '') ? (stored as Season) : '2027'
  })

  const setSeason = (s: Season) => {
    if (SEASON_LOCK) return // switcher disabled while locked
    localStorage.setItem('active-season', s)
    setSeasonState(s)
  }

  return (
    <SeasonContext.Provider value={{ season, setSeason, locked: SEASON_LOCK !== null }}>
      {children}
    </SeasonContext.Provider>
  )
}

export const useSeason = () => useContext(SeasonContext)
